import React from 'react'
import { useHistory } from 'react-router-dom'
import { isMobileOnly } from 'react-device-detect'

import { Column, Content, Text, GoBackContainer } from '../../components'

import { useStyle } from './returns.styles'

export const ReturnPage = () => {
  const history = useHistory()
  const classes = useStyle()

  const titlePreset = isMobileOnly ? 'h1Mobile' : 'h1'

  const isFromItemCard =
    history.location.state !== undefined &&
    history.location.state.prevPath.includes('/product')

  const handleGoBack = () => history.goBack()

  return (
    <Content className={classes.container} justifyContent="flex-start">
      {isFromItemCard && (
        <GoBackContainer
          text="Back to Product Page"
          textTx="returns.back.to.product.page"
          onClick={handleGoBack}
        />
      )}
      <Content
        className={classes.content}
        preset="part"
        justifyContent="flex-start"
      >
        <Column justifyContent="flex-start">
          <Text
            className={classes.title}
            text="Return"
            tx="returns.exchange.page.title"
            preset={titlePreset}
          />
          <Text
            className={classes.text}
            text="Looking to cancel your order?"
            tx="returns.exchange.page.second.title"
            preset="h5"
            color="inactive"
          />
          <Text
            className={classes.text}
            preset="body"
            text="An order can only be canceled by either the buyer or the seller within 24 hours of the order being placed. Go to Order control to cancel order or Contact customer service at support@ovaflopick.com if you have any questions."
            tx="returns.exchange.page.text"
          />
          <Column fullWidth alignItems="start">
            <Text
              className={classes.description}
              preset="body"
              text="Due to the customization nature, all items are final sale and not returnable."
              tx="returns.exchange.page.description.text"
            />
          </Column>
        </Column>
      </Content>
    </Content>
  )
}
